import config from 'config'
import { rootEpic, rootReducer } from 'modules'
import { stashIntegrationCookies } from 'modules/cookies'
import { applyMiddleware, compose, createStore } from 'redux'
import { ActionsObservable, createEpicMiddleware } from 'redux-observable'
import { RootState } from 'types/view'
import { LockedInterval } from 'utils/lockedInterval'
import actionSyncMiddleware from 'utils/redux/middleware/actionSyncMiddleware'

const devtoolsEnabled = config.ENV !== 'PRODUCTION'
const composeEnhancers = devtoolsEnabled && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: `${document.title} (${window.location.host.replace(/:[0-9]+/, '')}: ${window.location.pathname})`,
  trace: true
}) : compose
const epicMiddleware = createEpicMiddleware()

//we are extending the built in of type to handle our action prefix.
const originalOfType = ActionsObservable.prototype.ofType
ActionsObservable.prototype.ofType = (...types) => {
  return originalOfType.apply(this, types.map(type => (
    `${config.REDUX_ACTION_NAMESPACE}_${type}`
  )))
}

const configureStore = (initialState = {}) => {
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(
        actionSyncMiddleware,
        epicMiddleware
      )
    )
  )

  epicMiddleware.run(rootEpic)

  return store
}

const store = configureStore()

export default store as (typeof store & { name?: string })

let lockedInterval = new LockedInterval()

const getConductorData = ()=> {
  stashIntegrationCookies({getFreshData:true})
}

/**
 * @returns Typed version of state
 */
export const getStoreState = ()=> {

  // re-fetch integration data since it may initialize after the widget
  lockedInterval.run(()=>{getConductorData()})

  return (store.getState() as unknown) as RootState
}
